// @ts-ignore
import * as translations from "src/translations";
import App from "./app/App.vue";
import hcc from "@dev/hc-components";
import router from "./app/router";
import store from "./app/store";
import Vue from "vue";
import { HcLocalizerVuePlugin } from "@dev/hc-localization";
import "./module/api/service/PathsSettings";

Vue.config.productionTip = false;
const localizerOptions = {
    defaultCulture: process.env.VUE_APP_CULTURE,
    // @ts-ignore
    translations: translations.default
};

Vue.use(hcc, [
    "HcLabel",
    "HcFormRow",
    "HcInput",
    "HcHeader",
    "HcMain",
    "HcSection",
    "HcFooter",
    "HcButton",
    "HcPassword",
    "HcNewPassword",
    "HcMainRow",
    "HcSelect",
    "HcCol",
    "HcCard",
    "HcGrid",
    "HcTooltip",
    "HcMoney",
    "HcMaskedInput",
    "HcPhoneNumber",
    "HcModal",
    "HcLinkRaw",
    "HcTable",
    "HcRadio",
    "HcDatepicker",
    "HcFileUpload",
    "HcModalAlert",
    "HcCheck"
]);

Vue.use(HcLocalizerVuePlugin, localizerOptions);
// @ts-ignore
const localizer = Vue.prototype.$localizer || Vue.prototype.$hcLocalizer;
if (localizer && typeof localizer.addTranslations === 'function') {
    localizer.addTranslations('cs-CZ', translations.default);
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
